import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { StyledCard } from '../../components/Card/Card.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionProduct = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
});
var ContentWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column-reverse;\n    gap: ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column-reverse;\n    gap: ", ";\n\n    ", "\n\n    ", "\n  "])), theme.spacing[6], media.greaterThan('m')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        flex-direction: row;\n        gap: ", ";\n    "], ["\n        flex-direction: row;\n        gap: ", ";\n    "])), theme.spacing[12]), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }));
});
var Products = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n\n    ", "\n\n    .", " {\n      flex: 1;\n    }\n  "], ["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n\n    ", "\n\n    .", " {\n      flex: 1;\n    }\n  "])), theme.spacing[6], media.greaterThan('s')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        flex-direction: row;\n    "], ["\n        flex-direction: row;\n    "]))), StyledCard.styledComponentId);
});
var Content = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex: 1;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    flex: 1;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.spacing[6], theme.spacing[6]);
});
var SectionProduct = function (_a) {
  var name = _a.name,
    reference = _a.reference,
    background = _a.background,
    products = _a.products,
    content = _a.content;
  return jsx(StyledSectionProduct, {
    name: name,
    reference: reference,
    background: background,
    children: jsxs(ContentWrapper, {
      children: [jsx(Products, {
        children: products
      }), jsx(Content, {
        children: content
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { SectionProduct, StyledSectionProduct };
//# sourceMappingURL=SectionProduct.js.map
